import LoginOverride from 'Overrides/Authentication/LoginOverride';
import BaseOverride from 'Overrides/Authentication/BaseOverride';

module.exports = {
  LoginOverride,
  BaseOverride,
};
